// extracted by mini-css-extract-plugin
export default {"emote":"_3YS4a"};